
import React, { useEffect, useState } from 'react';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import Box from '../Box';
import { enqueueSnackbar } from 'notistack';
import { createPosbank } from 'http/components/SettingService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { setPosBanks } from '../../../../../Redux/slices/globalSlice';

export default function NewBank() {
  const dispatch = useDispatch();
  const [reset, setReset] = useState(false);
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'عنوان',
      value: '',
      icon: <icons.Type/>,
    },
  });
  
  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  useEffect(() => {
    if(reset) {
      setControls({ name: { value: '' } });
      setReset(false);
    }
  }, [reset])

  const onCreate = async () => {
    dispatch(HandleLoading(true));
    const { name } = controls;
    if(name.value && name.value !== '') {
      const response = await createPosbank(name.value);
      if(response.status) {
        enqueueSnackbar('دستگاه کارت‌خوان با موفقیت ثبت شد', {variant: 'success'});
        await dispatch(setPosBanks(response.data.bank));
        setReset(true);
      } 
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }
  
  return (
    <Box
      title={"ثبت دستگاه جدید"}
      body={
        <>
          <div className='w-100 flex-column-start-start mb-2'>
            {
              !reset && Object.keys(controls).map((key, index) => {
              return (
                <>
                  <small className='pe-1 mb-1'>{controls[key].placeholder}</small>
                  <Inputer
                    key={`inputer_${controls[key].id}`}
                    id={controls[key].id}
                    type={controls[key].type}
                    value={controls[key].value}
                    setValue={setControlsValue.bind(this)}
                    icon={controls[key].icon}
                    className={'mb-1'}
                    onKeyEnterActive
                    onKeyEnter={onCreate}
                  />
                </>
              )
              })
            }
          </div>
          <CButton
            text={'ذخیره دستگاه جدید'}
            icon={<icons.Save2/>}
            className={'my-3'}
            onClick={onCreate}
          />
        </>
      }
    />
  );
}